import { render, staticRenderFns } from "./AiDisclosureSummaryContent.vue?vue&type=template&id=63a95518"
import script from "./AiDisclosureSummaryContent.vue?vue&type=script&lang=js"
export * from "./AiDisclosureSummaryContent.vue?vue&type=script&lang=js"
import style0 from "./AiDisclosureSummaryContent.vue?vue&type=style&index=0&id=63a95518&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports